import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { RmPriceListAdapter } from './dto/rm-price-list.adapter';
import { RmPriceListController } from './rm-price-list.controller';
import { RmPriceList } from './rm-price-list.entity';
import { RmPriceListService } from './rm-price-list.service';

@Module({
  imports:[
    TypeOrmModule.forFeature([RmPriceList]),
  ],
  controllers: [RmPriceListController],
  providers: [RmPriceListService,ApplicationExceptionHandler,RmPriceListAdapter]
})
export class RmPriceListModule {}
